import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
const isFor = ['Hombres mayores de 55 años que notan un crecimiento constante de su circunferencia abdominal.', 'Caballeros que se sienten cansados, somnolientos o sin enfoque después de las comidas.', 'Personas con diagnóstico de pre-diabetes o resistencia a la insulina que quieren tomar el control de forma natural.', 'Hombres que quieren mantener su independencia física y vitalidad para disfrutar de su familia.'];
const isNotFor = ['Jóvenes deportistas que buscan suplementos de gimnasio.', "Personas que buscan una 'pastilla mágica' sin hacer cambios en sus hábitos.", 'Quienes no estén dispuestos a seguir un plan estructurado por al menos 48 horas.'];
export function TargetAudience() {
  return <section className="py-20 px-4 bg-navy-800" data-id="element-192">
      <div className="max-w-6xl mx-auto" data-id="element-193">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-194">
          {/* Who is it for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900 rounded-2xl p-8 border-t-4 border-t-green-500 shadow-lg" data-id="element-195">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center" data-id="element-196">
              <CheckCircle className="w-8 h-8 text-green-500 mr-3" data-id="element-197" />
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-198">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-199">
                  <CheckCircle className="w-6 h-6 text-green-500/70 mr-3 shrink-0 mt-0.5" data-id="element-200" />
                  <span className="text-gray-300 text-lg" data-id="element-201">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who is it NOT for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-navy-900 rounded-2xl p-8 border-t-4 border-t-red-500 shadow-lg opacity-80" data-id="element-202">
            <h3 className="text-2xl font-bold mb-8 text-white flex items-center" data-id="element-203">
              <XCircle className="w-8 h-8 text-red-500 mr-3" data-id="element-204" />
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-205">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-206">
                  <XCircle className="w-6 h-6 text-red-500/70 mr-3 shrink-0 mt-0.5" data-id="element-207" />
                  <span className="text-gray-400 text-lg" data-id="element-208">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}